import React from 'react'

/**
 * Sistema de diseño del módulo de Precios (scoped a .precios-scope).
 * Centraliza el look de botones, tabs (antd), header, toolbar y cards de sección
 * para que todas las pantallas se vean como un solo producto (no básicas).
 */
const CSS = `
.precios-scope{color:#1f2b38;}

/* Botones MUI */
.precios-scope .MuiButton-root{text-transform:none!important;padding:5px 14px!important;font-size:12.5px!important;min-width:0!important;box-shadow:none!important;line-height:1.6!important;border-radius:8px!important;font-weight:600!important;}
.precios-scope .MuiButton-contained:hover{box-shadow:0 2px 10px rgba(37,99,235,.25)!important;}

/* Header del módulo */
.precios-header{background:linear-gradient(120deg,#0f2439 0%,#20456a 100%);border-radius:14px;padding:18px 22px;margin-bottom:16px;box-shadow:0 4px 16px rgba(15,36,57,.12);}
.precios-header h2{color:#fff;margin:0;font-size:19px;font-weight:800;letter-spacing:.2px;}
.precios-header p{color:#c6d4e2;margin:5px 0 0;font-size:12.5px;}
.precios-header .precios-chip{display:inline-block;background:rgba(255,255,255,.12);color:#e8f0f8;border:1px solid rgba(255,255,255,.18);border-radius:20px;padding:2px 11px;font-size:11px;font-weight:600;margin-right:8px;}

/* Pipeline visual del flujo */
.precios-flow{display:flex;align-items:center;flex-wrap:wrap;gap:6px;margin-top:14px;}
.precios-flow .step{display:flex;align-items:center;gap:7px;background:rgba(255,255,255,.10);border:1px solid rgba(255,255,255,.16);border-radius:8px;padding:5px 11px;}
.precios-flow .step b{background:#fff;color:#0f2439;border-radius:50%;width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;}
.precios-flow .step span{color:#e8f0f8;font-size:11.5px;font-weight:600;}
.precios-flow .arrow{color:#7f97ad;font-size:15px;font-weight:700;}

/* Toolbar (selector de periodo, etc.) */
.precios-toolbar{display:flex;gap:10px;align-items:center;flex-wrap:wrap;background:#fff;border:1px solid #e6e9ee;border-radius:10px;padding:10px 14px;margin-bottom:16px;}

/* Card de sección (formularios / bloques) */
.precios-card{background:#fff;border:1px solid #e6e9ee;border-radius:12px;padding:18px 20px;margin-bottom:18px;box-shadow:0 1px 2px rgba(15,36,57,.04);}
.precios-card h3{margin:0 0 4px;font-size:14.5px;font-weight:700;color:#0f2439;}
.precios-section-title{font-size:14px;font-weight:700;color:#0f2439;margin:22px 0 8px;}

/* Tabs (antd) — indicador y estados */
.precios-scope .ant-tabs-nav{margin-bottom:16px;}
.precios-scope .ant-tabs-tab{padding:8px 2px!important;font-size:13px;color:#5b6673;transition:color .15s ease;}
.precios-scope .ant-tabs-tab:hover{color:#2563eb;}
.precios-scope .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{color:#0f2439!important;font-weight:700;}
.precios-scope .ant-tabs-ink-bar{background:#2563eb!important;height:3px!important;border-radius:3px;}

/* Inputs */
.precios-scope .MuiOutlinedInput-root{border-radius:8px;}

/* Paso a paso (antd Steps). Por defecto queda gris claro sobre blanco y no se distingue en que paso
   estas ni cuales quedaron atras. Se le da el mismo lenguaje que el resto del modulo: azul para el
   paso actual, verde para lo hecho, gris legible para lo que falta. */
.precios-pasos{background:#fff;border:1px solid #e6e9ee;border-radius:12px;padding:16px 20px 8px;margin-bottom:14px;box-shadow:0 1px 2px rgba(15,36,57,.04);}
.precios-scope .ant-steps-item-title{font-size:12.5px!important;font-weight:700!important;color:#0f2439!important;line-height:1.35!important;}
.precios-scope .ant-steps-item-description{font-size:11.5px!important;color:#6b7684!important;}
.precios-scope .ant-steps-item-wait .ant-steps-item-title{color:#8a94a0!important;font-weight:600!important;}
.precios-scope .ant-steps-item-wait .ant-steps-item-description{color:#9aa4ad!important;}

/* El circulito. El paso actual tiene que gritar donde estas; por eso el halo. */
.precios-scope .ant-steps-item-icon{width:26px!important;height:26px!important;line-height:24px!important;margin-inline-end:10px!important;}
.precios-scope .ant-steps-item-process .ant-steps-item-icon{background:#2563eb!important;border-color:#2563eb!important;box-shadow:0 0 0 4px rgba(37,99,235,.16);}
.precios-scope .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon{color:#fff!important;font-weight:800!important;}
.precios-scope .ant-steps-item-finish .ant-steps-item-icon{background:#e6f6ec!important;border-color:#1f9d55!important;}
.precios-scope .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon{color:#166534!important;}
.precios-scope .ant-steps-item-wait .ant-steps-item-icon{background:#f4f6f8!important;border-color:#c9d2db!important;}
.precios-scope .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon{color:#8a94a0!important;}

/* La linea que une los pasos: la de antd es casi invisible. Verde en el tramo ya recorrido. */
.precios-scope .ant-steps-item-title::after,
.precios-scope .ant-steps-item-tail::after{background:#dfe4ea!important;height:2px!important;}
.precios-scope .ant-steps-item-finish .ant-steps-item-title::after,
.precios-scope .ant-steps-item-finish .ant-steps-item-tail::after{background:#9fd8b6!important;}

/* Se puede volver a un paso anterior haciendo clic: que el cursor lo diga. */
.precios-scope .ant-steps-item-container{cursor:pointer;}
.precios-scope .ant-steps-item-process .ant-steps-item-container{cursor:default;}

/* Formularios largos: en vez de una fila que se parte donde caiga, grupos rotulados y una rejilla
   de columnas iguales. Los campos quedan alineados entre si y el orden de lectura sigue al flujo. */
.precios-form-grupo{margin-top:16px;}
.precios-form-grupo:first-of-type{margin-top:0;}
.precios-form-rotulo{display:flex;align-items:center;gap:8px;font-size:11px;font-weight:700;letter-spacing:.6px;text-transform:uppercase;color:#8a94a0;margin-bottom:9px;}
.precios-form-rotulo::after{content:'';flex:1;height:1px;background:#e6e9ee;}
.precios-form-rotulo .n{display:inline-flex;align-items:center;justify-content:center;width:17px;height:17px;border-radius:50%;background:#eef2f7;color:#4a5a6b;font-size:10.5px;font-weight:800;letter-spacing:0;flex:none;}
.precios-grid{display:grid;gap:12px;align-items:start;}
.precios-grid-1{grid-template-columns:minmax(0,1fr);}
.precios-grid-2{grid-template-columns:repeat(2,minmax(0,1fr));}
.precios-grid-3{grid-template-columns:repeat(3,minmax(0,1fr));}
/* El ancho lo manda la rejilla, no cada input. */
.precios-grid>.MuiFormControl-root,.precios-grid>.MuiAutocomplete-root{width:100%;}
.precios-grid .MuiFormHelperText-root{margin-left:2px;}
@media (max-width:1100px){.precios-grid-3{grid-template-columns:repeat(2,minmax(0,1fr));}}
@media (max-width:760px){.precios-grid-2,.precios-grid-3{grid-template-columns:minmax(0,1fr);}}
`

const PreciosStyles = () => <style>{CSS}</style>

export default PreciosStyles
